/* eslint-disable */
export default {
  dialPlaceholder: 'Naam of nummer invoeren',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
